import React, { useContext } from 'react';
import moment from 'moment';
import Rating from '@material-ui/lab/Rating';
import { ShiftProps } from '../../../interfacesProps/ShiftProps';
import { ObjectLiteral } from '../../../interfacesProps/ObjectLiteralProps';
import { Colors, FontSize, Spacing } from '../../../theme/Theme';
import {
  RenderTextWithTitle,
  renderTextWithTitleAndChildComponent,
} from '../../../components/TextWithHeader';
import { getShiftRatingSource, getShiftRatingValue } from '../../../util/shiftRating';
import { RBContext } from '../../../components/RBContext';

export interface ShiftRatingInformationProps {
  shift?: ShiftProps;
  account: ObjectLiteral;
}

const ShiftRatingInformation: React.FC<ShiftRatingInformationProps> = ({
  shift,
  account,
}) => {
  const { industryMode } = useContext(RBContext);

  if (!shift) {
    return null;
  }

  const ratingSource = getShiftRatingSource(shift, industryMode, account?.roleName);
  const ratingValue = getShiftRatingValue(shift, industryMode, account?.roleName);
  const commentValue = ratingSource?.comment ?? null;
  const dateValue = (ratingSource as any)?.date ?? (ratingSource as any)?.createdAt ?? null;

  const hasRating = typeof ratingValue === 'number' && Number.isFinite(ratingValue);
  const roundedRating =
    typeof ratingValue === 'number' && Number.isFinite(ratingValue)
      ? Math.max(0, Math.min(5, Math.round(ratingValue)))
      : 0;
  const hasComment = typeof commentValue === 'string' && commentValue.trim().length > 0;
  if (!hasRating && !hasComment) {
    return null;
  }

  const dateText =
    typeof dateValue === 'string' || dateValue instanceof Date
      ? moment(dateValue as any).format('MMM D, YYYY')
      : null;

  return (
    <div
      style={{
        paddingTop: Spacing.medium,
        paddingLeft: Spacing.large,
        paddingRight: Spacing.large,
      }}
    >
      <div
        style={{
          fontSize: FontSize.large,
          fontWeight: 'bold',
          marginBottom: Spacing.small,
        }}
      >
        Shift Rating
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: Spacing.medium,
        }}
      >
        {renderTextWithTitleAndChildComponent(
          'Rating',
          hasRating ? (
            <Rating value={roundedRating ?? 0} readOnly size="small" precision={1} />
          ) : (
            <div style={{ color: Colors.darkGrey, fontWeight: 'bold' }}>Not rated</div>
          ),
        )}

        {dateText ? RenderTextWithTitle('Date', dateText) : null}
      </div>

      {hasComment ? (
        <div style={{ marginTop: Spacing.small }}>
          {RenderTextWithTitle('Comment', commentValue as string)}
        </div>
      ) : null}

      <div
        style={{
          height: 1,
          backgroundColor: Colors.defaultGrey,
          marginTop: Spacing.medium,
          marginBottom: Spacing.medium,
        }}
      />
    </div>
  );
};

export default ShiftRatingInformation;
